/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Styled components for TableFooterItem
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.16.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';
import { ImgStyled } from '../../Block/Img';

export const TableFooterItemStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `table-footer__footer-item ${className || ''}`,
}))<IAttrStyled>`
    ${fonts.textSmall}
    height: 32px;
    padding: 6px 12px;
    width: 188px;
    box-sizing: border-box;
    cursor: pointer;
    background: ${colors.tableFooterMenuButtonBg};
    max-width: 100%;

    &.disabled {
        opacity: .5;
        cursor: default;
    }

    &:hover:not(.disabled) {
        border-radius: 18px;
        background: ${colors.tableFooterMenuButtonBgHover};
    }

    ${ImgStyled} {
        margin-right: 5px;
    }

    .table-footer__footer-item-container {
        display: flex;
        align-items: center;
    }
`;
